import React from 'react'
import { TitleBar, TitleAction, TitleContent } from '@pga/pga-component-library'
import { DetailChevron, ListItemLabel, RemoveAction } from './styled'
import { StyledInputField, CurrencyIcon, InputWithIconContainer } from '../../../shared.styles'

const InvoiceHeader = ({ toggle, isOpen, data: invoice, removeHandler, handleInvoiceAmountChange }) => (
  <TitleBar>
    <TitleContent onClick={toggle}>
      <DetailChevron isOpen={isOpen} />
      <ListItemLabel><h6>{invoice.description}</h6></ListItemLabel>
    </TitleContent>
    <TitleAction>
      <InputWithIconContainer>
        <StyledInputField
          tabIndex='0'
          width='120px'
          textAlign='right'
          type='number'
          step='0.01'
          role='textbox'
          value={invoice.value}
          onChange={handleInvoiceAmountChange(invoice.invoiceNum)}
          disabled
        />
        <CurrencyIcon>$</CurrencyIcon>
      </InputWithIconContainer>
      {removeHandler && invoice.removeable ? (<RemoveAction role='button' className='ml-2' onClick={removeHandler} />) : null}
    </TitleAction>
  </TitleBar>
)
export default InvoiceHeader
